import React from 'react';
import { TabType } from 'types/TabTypes';
import PageHeader from 'components/layout/PageHeader';
import NewsletterSendNotice, { useNewsletterSendStatus } from './NewsletterSendNotice';
import NewsletterList from './NewsletterList';
import NewsletterAudienceList from './NewsletterAudienceList';
import { NEWSLETTER_PATH } from './NewsletterTypes';
import '../../../style/scss/navigation.scss';
import '../../../style/scss/newsletters.scss';

// The overview of the newsletters: one page header with a tab for the newsletters and a tab for the audiences
const NewsletterOverviewPage: React.FC = () => {

    // Fetch whether newsletters can be sent from the environment
    const sendStatus = useNewsletterSendStatus();

    // The two tabs of the page, each with its own list
    const tabs: TabType[] = [
        { label: 'newsletters.overview.title', path: 'overview', component: <NewsletterList /> },
        { label: 'newsletters.audiences.title', path: 'audiences', component: <NewsletterAudienceList /> },
    ];

    return (
        <div className='container-center align-center newsletter-overview-page'>
            <div className='width-100'>
                <div className='container-filled'>
                    <NewsletterSendNotice status={sendStatus} />
                </div>
                <PageHeader
                    title='nav.newsletters_title'
                    explanationText='newsletters.overview.explanation'
                    tabs={tabs}
                    basePath={NEWSLETTER_PATH}
                    syncTabsWithUrl={true} />
            </div>
        </div>
    );
};

export default NewsletterOverviewPage;
